import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { back } from '../../fsm/events';

import { getIsFetching } from '../../selectors/coreApi';
import { getSettings } from '../../selectors/settings';
import { getSpinnerDeactivated, getStepperMax, getStepperValue } from '../../selectors/machineMeta';
import { getTimedout, getToken, isEmbed } from '../../selectors/global';
import { hasTechnicalError } from '../../selectors/error';
import { isWorkflowBackButtonEnabled, isNpsNeeded, isNpsAvailable } from '../../utils/coreApi';

export const useConnect = () => {
  const dispatch = useDispatch();
  return {
    hasTechnicalError: useSelector(hasTechnicalError),
    isFetching: useSelector(getIsFetching),
    isTimedout: useSelector(getTimedout),
    settings: useSelector(getSettings),
    spinnerDeactivated: useSelector(getSpinnerDeactivated),
    stepperMax: useSelector(getStepperMax),
    stepperValue: useSelector(getStepperValue),
    token: useSelector(getToken),
    isEmbedded: useSelector(isEmbed),
    isWorkflowBackButtonEnabled: useSelector(isWorkflowBackButtonEnabled),
    isNpsEligibilityNeeded: useSelector(isNpsNeeded),
    isNpsEligibilityAvailable: useSelector(isNpsAvailable),
    back: () => dispatch(back()),
  };
};

const removeServerSideStyles = () => {
  const jssStyles = document.getElementById('jss-server-side');

  if (jssStyles && jssStyles.parentNode) {
    jssStyles.parentNode.removeChild(jssStyles);
  }
};

export const useComponentDidMount = () => {
  useEffect(() => {
    removeServerSideStyles();
  }, []);
};
